module.exports = __webpack_public_path__ + "static/img/7.8a83d40f.jpg";